import { render, staticRenderFns } from "./Init.vue?vue&type=template&id=4319edfb&scoped=true&"
import script from "./Init.vue?vue&type=script&lang=js&"
export * from "./Init.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4319edfb",
  null
  
)

export default component.exports